"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

require("./icon.css");

var getStyle = function getStyle(props) {
  if (props.width && props.height) {
    return {
      width: props.width,
      height: props.height
    };
  }

  return null;
};

var Icon = function Icon(props) {
  var src = props.src,
      dataTestId = props.dataTestId,
      width = props.width,
      height = props.height,
      size = props.size,
      actionable = props.actionable,
      clickable = props.clickable,
      muted = props.muted,
      inactive = props.inactive,
      classes = props.classes,
      onClick = props.onClick,
      svg = props.svg;

  if (src) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      "data-testid": dataTestId,
      draggable: false,
      src: src,
      className: (0, _utils.gatherClasses)(props, "oui-dr-icon", "oui-svg-icon", !(width && height) ? "oui-".concat(size) : null, actionable ? "oui-actionable" : null, clickable ? "oui-clickable" : null, muted ? "oui-muted" : null, inactive ? "oui-inactive" : null),
      style: getStyle(props),
      alt: "svg-icon",
      onClick: props.onClick,
      "aria-hidden": "true"
    });
  }

  if (classes) {
    return /*#__PURE__*/_react["default"].createElement("i", {
      "data-testid": dataTestId,
      className: (0, _utils.gatherClasses)(props, "oui-dr-icon", "oui-font-icon", classes, actionable ? "oui-actionable" : null, clickable || actionable ? "oui-clickable" : null, muted ? "oui-muted" : null, inactive ? "oui-inactive" : null),
      "aria-hidden": "true",
      onClick: onClick
    });
  }

  if (svg) {
    return svg;
  }

  return null;
};

Icon.defaultProps = {
  size: "sm",
  actionable: false,
  clickable: false,
  inactive: false,
  muted: true,
  dataTestId: "orion-icon"
};
Icon.displayName = "OrionIcon";
Icon.propTypes = {
  src: _propTypes["default"].string,
  svg: _propTypes["default"].node,
  size: _propTypes["default"].oneOf(["xs", "sm", "md", "lg"]),
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  classes: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  actionable: _propTypes["default"].bool,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  inactive: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string
};
var _default = Icon;
exports["default"] = _default;